import React, { Component } from 'react';


class Rufti extends Component {
    render(){

    
    return (
        <div>
            <h2>Layout Register</h2>
        </div>
        
    );
}
}

export default Rufti